import { useState, useEffect } from "react";
import { useDeleteConfirmation } from "../../components/common";


import { NXDelete, NXEditPen } from "../../icons";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import CollectionModal from "./modal";
import useApi from "../../api";
import { boolIndicator } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

import { fetchCollections } from "../../redux/collectionsSlice";
import GenericSelectableTable from "../../components/selectableTable";


function CollectionTable() {

    const collections = useSelector((state: RootState) => state.collections);
    const [edit, setEdit] = useState<any>();
    const [openModal, setOpenModal] = useState(false)

    const api = useApi();
    const dispatch = useDispatch()
    const { handleDelete } = useDeleteConfirmation();

    const getCollection = () => {
        dispatch(fetchCollections() as any)
    };

    const onModalOpen = (editId?: number) => {
        setOpenModal(!openModal);
        if (editId) {
            setEdit(editId);
        }
    };

    const onModalClose = () => {
        setOpenModal(!openModal);
        setEdit('');
    };

    const onModalSubmit = () => {
        dispatch(fetchCollections() as any);
    };


    useEffect(() => {
        if (!collections.results.length) {
            dispatch(fetchCollections() as any);
        }
    }, []);
    
    const columns = [
        {
            header: "ID", key: "id"
        },
        {
            header: "Name", key: 'name'
        },
        {
            header: "Active", key: "is_active", render: (item: any)=>(
                boolIndicator(item)
            )
        },
        {
            header: "Action", key: "", render: (item:any) => (
                <>
                    <button className="p-1" onClick={() => {
                        handleDelete(item.id, 'Collection', api.deleteCollection, getCollection)
                    }}>
                        <NXDelete />
                    </button>
                    <button className="p-1" onClick={(e) => onModalOpen(item.id)}>
                        <NXEditPen />
                    </button>
                </>
            )
        }
    ] 
    

    return (
        <>
            <div className="flex justify-between pl-[5%] pt-[5%] md:pl-10 md:pr-10 md:pt-10">
                <div></div>
                <div>
                    <button
                    className="text-white bg-primary-600 px-10 py-3 rounded-xl font-nunito font-[900]"
                    onClick={(e) => onModalOpen()}
                    >
                    Add Collection
                    </button>
                    
                </div>
                
            </div>
            
            <PageBodyWrapper>
                <div className="relative overflow-x-auto px-1 pt-2">
                    <GenericSelectableTable columns={columns} data={collections.results}/>
                </div>
            </PageBodyWrapper>

            {openModal && <CollectionModal  isOpen={openModal} edit={edit} onClose={onModalClose} onSubmit={onModalSubmit} /> }
        </>
    );
}

export default CollectionTable;
